import { SkeletonBlock } from "@/interface/ShareWindow/Skeletons/SkeletonBlock";

export const InputSkeleton = () => (
    <SkeletonBlock width={520} height={25} style={{ marginBottom: "15px" }} />
);
